window.__ada = {
    initialized: false,
    features: {
        auth: false,
        sse: false,
        upload: false,
        feedback: false,
        env_banner: false,
        footer_build_time: false,
    },
    errors: [],
};
document.body.setAttribute('data-ada-preload', 'true');

window.addEventListener('error', (e) => {
    // WHY: window.__ada is assigned at module top so the optional chain always fires.
    window.__ada?.errors.push({ type: 'error', message: e.message, source: e.filename, line: e.lineno });
});
window.addEventListener('unhandledrejection', (e) => {
    window.__ada?.errors.push({ type: 'unhandledrejection', message: String(e.reason) });
});

export const API = '';
export const POLL_INTERVAL = 2000;

/** @param {number} ms @returns {Promise<void>} */
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * authFetch — the single auth-bearing fetch seam for the SPA.
 *
 * Two auth paths:
 *  1. Authenticated (Supabase identity present): attach the Bearer headers.
 *  2. Anonymous (no Supabase identity): the server's `_require_spa_mediation_or_auth`
 *     gate (branch 3) requires the `ada_spa_bootstrap` HMAC cookie. That cookie is
 *     minted by a fire-and-forget `POST /api/anon/bootstrap` at page load (init.ts).
 *     If the user uploads before that POST resolves, the cookie is absent and the
 *     request 401s. We close that race by AWAITING `__adaEnsureBootstrap()` here —
 *     wiring the mitigation init.ts:174-176 already promised. This benefits ALL
 *     upload sites at once (single POST + chunked init/chunk/complete + retry), since
 *     every one of them routes through authFetch (the DRY win, CLAUDE.md rule #11).
 *
 * RCA: docs/design/p0-staging-web-bugs-rca-260626.md §2.3 RC-B1 (the race, confirmed
 * by the runtime curl: /api/anon/bootstrap → 200 + Set-Cookie, upload-without-cookie → 401).
 *
 * @param {string} url
 * @param {{ headers?: Record<string, string> } & Omit<RequestInit, 'headers'>} [opts]
 * @returns {Promise<Response>}
 */
export async function authFetch(url, opts = {}) {
    const headers = window.adatool?.supabase ? await window.adatool.supabase.getAuthHeaders() : {};
    if (Object.keys(headers).length > 0) {
        opts.headers = { ...headers, ...(opts.headers || {}) };
        return fetch(url, opts);
    }
    // Anonymous request: ensure the ada_spa_bootstrap cookie is present before we
    // fire, so the server's anonymous-upload gate (branch 3) sees it. Best-effort:
    // __adaEnsureBootstrap swallows its own failures, so a bootstrap outage degrades
    // to a 401 that the caller's recovery branch handles — never a thrown error here.
    if (typeof window.__adaEnsureBootstrap === 'function') {
        try { await window.__adaEnsureBootstrap(); }
        catch (_e) { /* best-effort; never block the request on bootstrap */ }
    }
    return fetch(url, opts);
}

// WHY: esc.js always sets window.adatool.esc before any ES-module runs (load
// order guaranteed by the <script> tag preceding the <script type=module>).
// Cast removes the optional type since the value is always present at run time.
export const esc = /** @type {(input: string) => string} */ (window.adatool?.esc);
